import React from 'react'
import { FlexColumn, Text, Anchor, Icon } from 'elements'

export default function ConnectionReportStatus() {
  return (
    <FlexColumn p="xxlarge" alignItems="center">
      <Icon name="exclamation-circle" color="neutral.2" size="xxlarge" mb="medium" />
      <Text fontSize="xlarge" color="neutral.0" mb="xxxlarge">
        Connection Error
      </Text>
      <Text color="neutral.0" textAlign="center" mb="xxxlarge">
        Your integration could not be connected. Please reconnect and try again. Feel free to review
        our support documentation or create a ticket{' '}
        <Anchor href="https://scrutinize.freshdesk.com/support/home" target="_blank">
          here.
        </Anchor>
      </Text>
    </FlexColumn>
  )
}
